import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    associationDiscipline: {
        fontSize: "20px",
        color: "white",
        marginTop: "0.25%",
        display: "table-cell",

        float: "left",
        justifyContent: "center",
    },

    logo: { marginLeft: "35%" },
}));

export { useStyles };
